import { createStore, applyMiddleware } from 'redux';
import rootReducer from 'reducers';
import { PersistLogin } from 'reducers/middleware/persist-login';
import { checkTokenExpirationMiddleware } from 'reducers/middleware/check-token-expiration';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import { compose } from 'recompose';
import { createLogger } from 'redux-logger';

const persistedState = {
  auth: {
    token: sessionStorage.getItem('token') || '',
  },
};

const logger = createLogger({
  /* Logging level options. Remove an option to remove them from the console log */
  //level: 'log' | 'console' | 'warn' | 'error' | 'info',

  //timestamp: true, // Adds a timestamp to each log

  /* This function will be called before each action is processed with the middleware */
  //predicate: foo(),

  collapsed: true, // Auto-collapses all log entries
});

// Only add the redux logger middleware when we are not in production mode.
let middleware = [
  thunk,
  promise(),
  PersistLogin,
  checkTokenExpirationMiddleware,
];
if (process.env.NODE_ENV !== 'production') {
  middleware = [...middleware, logger];
}

const configureStore = () => {
  const store = createStore(
    rootReducer,
    persistedState,
    // logger has to be the last middleware in the chain
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? compose(
          applyMiddleware(...middleware),
          window.__REDUX_DEVTOOLS_EXTENSION__()
        )
      : applyMiddleware(...middleware)
  );

  return store;
};

export default configureStore;
